import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import './styles/archonBackground.css';
import './custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import archonQueryClient from './config/queryClient';

const basename = process.env.REACT_APP_BASENAME || '/';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={archonQueryClient}>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
      {/* Global toast notifications (notify helper in components/ui/feedback/notify) */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        newestOnTop
        theme="colored"
        style={{ zIndex: 'var(--archon-z-toast)' }}
      />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
